var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2228_8636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.625C11.6396 5.625 8.90625 8.3584 8.90625 11.7188C8.90625 15.0791 11.6396 17.8125 15 17.8125C18.3604 17.8125 21.0938 15.0791 21.0938 11.7188C21.0938 8.3584 18.3604 5.625 15 5.625ZM18.2812 14.5312C18.2812 15.0641 17.8373 15.4928 17.2989 15.4677C16.7945 15.4442 16.4062 15.0099 16.4062 14.5049V12.9492C16.4062 12.7874 16.2751 12.6562 16.1133 12.6562H13.8867C13.7249 12.6562 13.5938 12.7874 13.5938 12.9492V14.5049C13.5938 15.0099 13.2055 15.4443 12.7011 15.4677C12.1627 15.4928 11.7188 15.0641 11.7188 14.5312V8.93256C11.7188 8.4276 12.107 7.9933 12.6114 7.96981C13.1498 7.94473 13.5938 8.3734 13.5938 8.90625V10.4883C13.5938 10.6501 13.7249 10.7812 13.8867 10.7812H16.1133C16.2751 10.7812 16.4062 10.6501 16.4062 10.4883V8.93256C16.4062 8.4276 16.7945 7.9933 17.2989 7.96981C17.8373 7.94473 18.2812 8.3734 18.2812 8.90625V14.5312Z",
    fill: "#789BE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0C8.53828 0 3.28125 5.25703 3.28125 11.7188C3.28125 16.3299 5.94369 20.8083 8.89043 24.3322C11.6174 27.593 14.3092 29.7123 14.4223 29.8008C14.7591 30.0644 15.2358 30.0684 15.5777 29.8008C15.6908 29.7123 18.3826 27.593 21.1096 24.3322C24.0555 20.8093 26.7188 16.3307 26.7188 11.7188C26.7188 5.25703 21.4617 0 15 0V0ZM15 19.6875C10.6061 19.6875 7.03125 16.1127 7.03125 11.7188C7.03125 7.3248 10.6061 3.75 15 3.75C19.3939 3.75 22.9688 7.3248 22.9688 11.7188C22.9688 16.1127 19.3939 19.6875 15 19.6875Z",
    fill: "#789BE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2228_8636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c6a2ee114d1a2654bbabbfa72115b656.svg";
export { ForwardRef as ReactComponent };